<template>
    <div class="slider slider-cards">
        <div class="slider-cards__inner">
            <div class="container">
                <div class="slider-cards__wrap">
                    <swiper
                        :navigation="{
                            prevEl: btnPrev,
                            nextEl: btnNext,
                        }"
                        :modules="modules"
                        :spaceBetween="30"
                        v-bind="params"
                    >
                        <slot></slot>
                    </swiper>
                    <div class="slider-cards__btns">
                        <button class="swiper-button-prev" ref="btnPrev" v-if="nav">
                            <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                            </svg>
                        </button>
                        <button class="swiper-button-next" ref="btnNext" v-if="nav">
                            <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
    name: 'SliderCards',
    props: {
        params: {
            type: Object,
            default: () => {}
        },
        nav: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    setup: (props, ctx) => {

        const btnNext = ref(null)
        const btnPrev = ref(null)

        return {
            modules: [Navigation, Pagination],
            btnNext,
            btnPrev,
        }
    },
}
</script>


<style lang="scss">
    .slider-cards {
        &__wrap {
            position: relative;
        }
        .swiper {
            @include mobile {
                padding-left: 15px;
                padding-right: 15px;
                margin-left: -15px;
                margin-right: -15px;
            }
            &-button {
                &-prev {
                    left: -64px;
                }
                &-next {
                    right: -64px;
                }
                &-prev,
                &-next {
                    @include desktopSm {
                        position: relative;
                        left: auto;
                        right: auto;
                        top: auto;
                        margin: 0;
                    }
                }
                &-next {
                    @include desktopSm {
                        margin-left: 10px;
                    }
                }
            }
            &-slide {
                height: auto;

                & > * {
                    height: 100%;
                }
            }

            &-pagination {
                top: auto !important;
                left: auto !important;
                bottom: auto !important;
                position: relative;
                margin-top: 20px;
                &-bullet {
                    background: var(--c-gray-700);
                    opacity: 1;
                    &-active {
                        background: var(--c-gray-500);
                    }
                }
            }
        }

        &__btns {
            @include desktopSm {
                position: absolute;
                right: 0;
                top: -55px;
                display: flex;
            }
            @include mobile {
                display: none;
            }
        }
    }
</style>